// @ts-ignore
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';
import React from 'react';
import { Query } from 'react-apollo';

import { Target } from 'entities/Message';

// @ts-ignore
import SplitComposerHeader from './SplitComposerHeader';
// @ts-ignore
import SelectRecipientPanel, { SelectRecipientTabs } from './SelectRecipientPanel';
import { ComposerContext } from './ComposerContext';
import COMPOSER_ORGS_QUERY from 'chat/queries/ComposerOrgsQuery.gql';
import { ComposerOrgs } from 'chat/queries/__generated__/ComposerOrgs';
import { ComposerState } from 'chat_v2/ComposerContext';

export type MessageType = 'urgent' | 'message';

export type Props = {
  defaultTab?: SelectRecipientTabs;
  initialTargets?: Target[];
  onSignificantChangeMade?: () => void;
  onDismiss?: () => void;
  onPageChange?: () => void;
  messageType: MessageType;
  shareSdkBodyUrl?: string;
  clearSelection: () => void;
};

type FullProps = Props & ComposerState;

type DefaultProps = { messageType: MessageType };

type State = {
  studentIdListCreated: boolean;
};

export default class SplitComposer extends React.Component<FullProps, State> {
  static defaultProps: DefaultProps = { messageType: 'message' };

  constructor(props: FullProps) {
    super(props);

    this.state = {
      studentIdListCreated: false,
    };
  }

  componentDidUpdate(prevProps: FullProps, prevState: State) {
    const changed =
      prevState.studentIdListCreated !== this.state.studentIdListCreated ||
      (Object.keys(prevProps.recipients).length !== Object.keys(this.props.recipients).length);

    if (changed) {
      if (this.props.onSignificantChangeMade) {
        this.props.onSignificantChangeMade();
      }
    }
  }

  advanceToComposeMessage = () => {
    if (this.props.onPageChange) {
      this.props.onPageChange();
    }
  };

  handleSuccessfulStudentIdListCreation = () => {
    this.setState({ studentIdListCreated: true });
  };

  render() {
    const {
      messageType,
      recipients,
      filters,
      clearSelection,
    } = this.props;

    const isUrgentMessage = messageType === 'urgent';

    return (
      <React.Fragment>
        <ComposerContext.Provider
          value={{
            isUrgentMessage,
            messageType: 'message', // note this is default and should be changed here in the future
            // eslint-disable-next-line object-shorthand
            getUIEventContext: function() {
              return {
                message_type: this.messageType,
                is_urgent: this.isUrgentMessage,
                composer_version: 'web_full_page',
              };
            },
          }}>
          <SplitComposerHeader messageType={messageType} />
          <Query<ComposerOrgs> query={COMPOSER_ORGS_QUERY}>
            {({ data }) => {
              const orgs = data?.me?.organizations;
              const schools =
                orgs && orgs.filter(o => o.type === 'School' && o.permissions.canSendAnnouncement);
              return (
                <SelectRecipientPanel
                  onContinue={this.advanceToComposeMessage}
                  onTabChange={clearSelection}
                  onSuccessfulStudentIdListCreation={this.handleSuccessfulStudentIdListCreation}
                  defaultTab={this.props.defaultTab}
                  messageType={messageType}
                  schools={schools}
                  selection={recipients}
                  filters={filters}
                />
              );
            }}
          </Query>
        </ComposerContext.Provider>
      </React.Fragment>
    );
  }
}

// we export this for the SplitComposerModal integration test
// because TargetByStudentIdUploadPage expects a DragDropContext
const SplitComposerWithDnD = DragDropContext(HTML5Backend)(SplitComposer);

export { SplitComposerWithDnD };
